<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h3 class="font-italic py-4">Add Location</h3>
            <div class="text-large">What are the places where my company is located and does business?</div>
        </div>
    </div>
    <form [formGroup]="zipcodeAddForm">
        <div class="container-fluid py-4">
            <div class="row">
                <div class="col-12 light-theme-alt py-3">
                    <div class="row">
                        <label class="col-12 subtitle" for="zipcode">Zip Code</label>
                        <input type="number" inputmode="numeric" pattern="[0-9]*" formControlName="zipcode" class="form-control text-xlarge col-12 mx-3"
                            placeholder="Type to see results">
                    </div>
                </div>
            </div>
            <div class="row pt-3">
                <button class="col btn btn-primary" (click)="addLocation()">Add Location</button>
            </div>
        </div>
    </form>
</div>